import {AppBar, Box, Tab, Tabs} from '@material-ui/core';
import {useTheme} from '@material-ui/core/styles';
import {PageTab, TabPanel} from 'components';
import useBrowserTitle from 'hooks/useBrowserTitle';
import React, {useEffect, useState} from 'react';
import {useHistory, useParams} from 'react-router-dom';
import {toKebabCase} from './forms/locale/utils';
import {makeStyles} from '@material-ui/core/styles';
import LoadingPage from './LoadingPage';
import {CloudErrorPage} from './LoadingPage';
import withWidth from '@material-ui/core/withWidth';
import {useWindowSize} from 'hooks';
import {drawerWidth} from './ResponsiveNav';

const useStyles = makeStyles(theme => ({
    tabRoot: {
        justifyContent: 'center',
    },
    tabScroller: {
        flexGrow: '0',
    },
}));

const tpProps = index => {
    return {
        id: `tab-${index}`,
        key: `tab-${index}`,
        value: index,
        'aria-controls': `tabpanel-${index}`,
    };
};

const PageContentBox = ({children}) => {
    return (
        <Box
            paddingTop='1em'
            paddingBottom='5em'
            height='100%'
            style={{overflowX: 'auto', overflowY: 'hidden'}}
        >
            {children}
        </Box>
    );
};

const Page = ({
    tabs = [],
    tabsDisabled = {},
    pageUrl,
    componentProps,
    defaultTab = null,
    isLoading = false,
    error = null,
    useTitle = true,
    width,
}) => {
    const classes = useStyles();
    const history = useHistory();
    const {width: viewWidth} = useWindowSize();
    const theme = useTheme();
    const {tab: pageTab} = useParams();
    const extTabs = tabs.map(tab => {
        return {...tab, url: tab.url || toKebabCase(tab.name)};
    });
    Object.keys(tabsDisabled)?.forEach(
        item =>
            (extTabs.find(tab => tab.url === item)['disabled'] = tabsDisabled[item])
    );
    const tabNames = extTabs.map(tab => tab.url);
    const [section, setSection] = useState(
        tabNames.includes(pageTab) ? pageTab : defaultTab || tabNames[0]
    );
    useBrowserTitle(
        useTitle &&
            `| ${
                extTabs.find(tab => tab.url === section)?.title ||
                extTabs.find(tab => tab.url === section)?.name ||
                ''
            }`
    );

    useEffect(() => {
        setSection(tabNames.includes(pageTab) ? pageTab : defaultTab || tabNames[0]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabs]);

    const handleSectionChange = (event, newValue) => {
        setSection(newValue);
        history.push(`/${pageUrl}/${newValue}`);
    };

    return isLoading !== false ? (
        <LoadingPage />
    ) : error ? (
        <CloudErrorPage error={error} />
    ) : (
        <Box
            height='100%'
            width={
                width
                    ? width
                    : viewWidth < theme.breakpoints.values.lg
                    ? '100%'
                    : `calc(100% - ${drawerWidth})`
            }
        >
            <AppBar position='static' color='gray.light' elevation={1}>
                <Tabs
                    value={section}
                    indicatorColor='primary'
                    textColor='primary'
                    onChange={handleSectionChange}
                    aria-label='sea services view picker'
                    variant='scrollable'
                    scrollButtons='on'
                    classes={{
                        root: classes.tabRoot,
                        scroller: classes.tabScroller,
                    }}
                >
                    {extTabs.map(tab => (
                        <Tab
                            label={tab.name}
                            disabled={tab.disabled}
                            {...tpProps(tab.url)}
                        />
                    ))}
                </Tabs>
            </AppBar>
            <PageContentBox>
                {extTabs.map(tab => (
                    <TabPanel value={section} index={tab.url} key={tab.url}>
                        {React.createElement(tab.component, {
                            selectedTab: section,
                            ...componentProps,
                        })}
                    </TabPanel>
                ))}
            </PageContentBox>
        </Box>
    );
};

const SinglePage = ({title, children, ...rest}) => {
    useBrowserTitle(`| ${title}`);

    return (
        <PageContentBox>
            <PageTab {...rest}>{children}</PageTab>
        </PageContentBox>
    );
};

export default withWidth()(Page);
export {PageContentBox, SinglePage};
